import { render, staticRenderFns } from "./Check.vue?vue&type=template&id=c1c52db0&scoped=true"
import script from "./Check.vue?vue&type=script&lang=js"
export * from "./Check.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c52db0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1c52db0')) {
      api.createRecord('c1c52db0', component.options)
    } else {
      api.reload('c1c52db0', component.options)
    }
    module.hot.accept("./Check.vue?vue&type=template&id=c1c52db0&scoped=true", function () {
      api.rerender('c1c52db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/Check.vue"
export default component.exports